import { ServerURL } from "../../config.js"

let subfolder = "career-path"

export const Config = {
	server: {
		getData: ServerURL + subfolder + "/getData.php",
		pdfjsWorker: ServerURL + subfolder + "/pdf.worker.min.js",
		analyzeCourseDescription: ServerURL + "csprofiler/analyzeCourseDescription.php",
		analyzeUrl: ServerURL + subfolder + "/analyzeUrl.php",
		suggestTrainings: ServerURL + subfolder + "/suggestTrainings.php",
	},
}
